import { createSlotRecipe } from './runtime';

const alertConfig = {"name":"alert","slots":["root","content","description","icon","title"]}

export const alert = /* @__PURE__ */ createSlotRecipe(alertConfig)